import { getHttpClient } from '@/singleton-clients';

export async function loadGlobals() {
	const httpClient = getHttpClient();
	const response = await httpClient.get('api/globals');
	return response;
}
